import { ReactNode, createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export type Language = 'pl' | 'en';

interface LanguageContextProps {
	language: Language;
	setLanguage: (lang: Language) => void;
}
const defaultLanguageContext: LanguageContextProps = {
	language: 'pl',
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	setLanguage: () => {},
};
export const LanguageContext = createContext(defaultLanguageContext);

// Polish is the primary language; /en switches to English.
export const LanguageProvider = ({ children }: { children: ReactNode }) => {
	const [language, setLanguage] = useState<Language>('pl');
	const location = useLocation();

	useEffect(() => {
		setLanguage(location.pathname.startsWith('/en') ? 'en' : 'pl');
	}, [location]);

	useEffect(() => {
		document.documentElement.lang = language;
	}, [language]);

	return <LanguageContext.Provider value={{ language, setLanguage }}>{children}</LanguageContext.Provider>;
};
